<nav class="simple-navigation" appAccordion>
  <div *ngFor="let menuitem of menuItems">
    <!-- Regular Navigation Item -->
    <div class="nav-item" *ngIf="menuitem.type === 'link' && !menuService.showItem(menuitem.state)">
      <a class="nav-link" [class.active]="isActive('/' + menuitem.state)" 
         [routerLink]="['/', menuitem.state]" 
         (click)="onMenuItemClick($event)">
        <i class="nav-icon {{ menuitem.icon }}"></i>
        <span class="nav-text">{{ menuitem.name | translate }}</span>
        <span class="badge" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      </a>
    </div>

    <!-- External Link -->
    <div class="nav-item" *ngIf="menuitem.type === 'extLink' && !menuService.showItem(menuitem.state)">
      <a class="nav-link" href="{{menuitem.state}}" (click)="onMenuItemClick($event, true)" >
        <i class="nav-icon {{ menuitem.icon }}"></i>
        <span class="nav-text">{{ menuitem.name | translate }}</span>
        <span class="badge" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      </a>
    </div>

    <!-- External Tab Link -->
    <div class="nav-item" *ngIf="menuitem.type === 'extTabLink' && !menuService.showItem(menuitem.state)">
      <a class="nav-link" href="{{menuitem.state}}" target="_blank" (click)="onMenuItemClick($event, true)">
        <i class="nav-icon {{ menuitem.icon }}"></i>
        <span class="nav-text">{{ menuitem.name | translate }}</span>
        <span class="badge" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
      </a>
    </div>

    <!-- Submenu Parent -->
    <div class="nav-item" appAccordionLink group="{{menuitem.state}}" *ngIf="menuitem.type === 'sub' && !menuService.showItem(menuitem.state)">
      <!-- Simple dropdown toggle with the correct directive -->
      <a class="nav-link" appAccordionToggle href="javascript:;">
        <i class="nav-icon {{ menuitem.icon }}"></i>
        <span class="nav-text">{{ menuitem.name | translate }}</span>
        <span class="badge" *ngFor="let badge of menuitem.badge">{{ badge.value }}</span>
        <i class="dropdown-arrow material-icons">keyboard_arrow_down</i>
      </a>

      <!-- Submenu Items -->
      <div class="dropdown-menu">
        <a *ngFor="let childitem of menuitem.children" 
           [routerLink]="['/', menuitem.state, childitem.state]" 
           class="dropdown-item"
           [class.active]="isActive('/' + menuitem.state + '/' + childitem.state)"
           (click)="onMenuItemClick($event)">
          <span>{{ childitem.name | translate }}</span>
          <span class="badge" *ngFor="let badge of childitem.badge">{{ badge.value }}</span>
        </a>
      </div>
    </div>

    <!-- Navigation Divider -->
    <div class="divider" *ngIf="menuitem.type === 'divider'"></div>

    <!-- Navigation Section Title -->
    <div class="section-title" *ngIf="menuitem.type === 'title'">
      {{ menuitem.name | translate }}
    </div>
  </div>
</nav>
